// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../types';

import gql from 'graphql-tag';
export type ContactsProposalFragment = { __typename?: 'Proposal', space: { __typename?: 'SelfServeSpace', hostContact: { __typename?: 'HostContact', email?: string | null, phoneNumber?: string | null }, venue?: { __typename?: 'SelfServeVenue', name?: string | null } | null } };

export const ContactsProposalFragmentDoc = gql`
    fragment ContactsProposal on Proposal {
  space {
    hostContact {
      email
      phoneNumber
    }
    venue {
      name
    }
  }
}
    `;